import {Pipe, PipeTransform} from '@angular/core';
import {UnitsFormattersFactory} from '../units-formatters/units-formatters.factory';
import {ColumnUnits} from '../units-formatters/units-formatters.service';

@Pipe({
  name: 'unitsFormatter'
})
export class UnitsFormatterPipe implements PipeTransform {
  constructor(private readonly unitsFormatterFactory: UnitsFormattersFactory) {
  }

  transform(value: string, columnUnits: ColumnUnits): string {
    const formatter = this.unitsFormatterFactory.getFormatter(columnUnits);
    return formatter.apply(value);
  }
}
